var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"payment"},[_c('div',{staticClass:"con"},[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"button",on:{"click":_vm.close}},[_vm._v("确定")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }